@import '../../../constants/spacing.module.less';

.cost-review-modal-footer {
  height: auto;
  min-height: auto;
  display: flex;
  flex-flow: column nowrap;
  gap: @space-12;
  padding: @space-12 @space-16;
}

.cost-review-modal-footer-buttons-container {
  display: flex;
  justify-content: flex-end;
  gap: @space-16;
}
